import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AddLeadComponent } from './addlead.component';
//import { LeadsService } from '../../services/lead-service/lead-service.service';
import {SlimLoadingBarModule} from 'ng2-slim-loading-bar';
import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';

import { Http, Response } from '@angular/http';
import { FormsModule} from '@angular/forms';
import { FormBuilder, NgForm, NgModel, Validators, ValidatorFn } from '@angular/forms'

import { NgSelectModule } from '@ng-select/ng-select';
import { DropdownModule as primeDropdown } from 'primeng/dropdown';
import { Ng2TelInputModule } from 'ng2-tel-input';
import { HeaderModule } from '../../layout/header/header.module';
import { IdDocumentScanModule } from "../../shared/components/id-document-scan/id-document-scan.module";


@NgModule({
  declarations: [
    AddLeadComponent
  ],
  imports: [
    IdDocumentScanModule,
    BrowserModule,FormsModule,SlimLoadingBarModule.forRoot(),
    SweetAlert2Module,
    NgSelectModule,
    primeDropdown,
    HeaderModule,
    Ng2TelInputModule
  ],
  providers: [Http,FormBuilder],
  bootstrap: [AddLeadComponent],
  exports: [AddLeadComponent,SlimLoadingBarModule],
})
export class AddLeadModule { }


// WEBPACK FOOTER //
// ./src/app/lead/addLead/addlead.module.ts